export default __webpack_public_path__ + "static/media/napaLogo.89304aac.svg";